import React, { useEffect } from "react";

export function UndoToast({ message, visible, onUndo, onDismiss, duration = 5000 }) {
  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(() => onDismiss?.(), duration);
    return () => clearTimeout(timer);
  }, [visible, duration, onDismiss]);

  return (
    <div
      className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 bg-gray-800 text-white px-5 py-3 rounded-lg shadow-lg transition-all duration-300 ease-in-out ${
        visible
          ? "translate-y-0 opacity-100"
          : "translate-y-4 opacity-0 pointer-events-none"
      }`}
    >
      <span className="text-lg">✅</span>

      <span className="text-sm font-medium">{message}</span>

      <button
        onClick={() => {
          onUndo?.();
          onDismiss?.();
        }}
        className="ml-2 text-sm font-semibold text-blue-400 hover:text-blue-300 transition-colors"
      >
        Undo
      </button>

      <button
        onClick={() => onDismiss?.()}
        className="ml-1 text-gray-400 hover:text-white transition-colors text-lg leading-none"
      >
        ×
      </button>
    </div>
  );
}
